import { useEffect } from 'react';
import { applyOneTrustTrackers } from './consent';

// Headless: OneTrust renders its own banner DOM; this only re-runs category
// gating whenever consent changes. Rendered in place of <ConsentBanner/>.
export default function OneTrustGate() {
  useEffect(() => {
    applyOneTrustTrackers();
    const onChange = () => applyOneTrustTrackers();
    window.addEventListener('OneTrustGroupsUpdated', onChange);
    window.addEventListener('ot-consent-ready', onChange);
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', onChange);
      window.removeEventListener('ot-consent-ready', onChange);
    };
  }, []);
  return null;
}
